import React, {useEffect} from 'react';
import {Box, Grid, Typography} from '@material-ui/core';
import {HorizontalBar} from "react-chartjs-2";
import ResultBarPie from "./ResultBarPie";
import PieChart from '@user-components/PieChart';

const getUnstableLevel = (value) => {
    if (value < 25) return { text: '안정', color: '#4CAF50', desc: '불안정 요소가 낮은 안정적인 상태입니다.' }
    if (value < 50) return { text: '경미', color: '#FFC107', desc: '경미한 불안정이 감지됩니다. 지속적인 관찰이 필요합니다.' }
    if (value < 75) return { text: '주의', color: '#FF9800', desc: '불안정 수준이 높습니다.' }
    return { text: '심각', color: '#F44336', desc: '불안정 수준이 매우 높습니다. 적극적인 뇌기능 훈련이 필요합니다.' }
}

const ResultEmotion = (props) => {
    const { measureData, fontSize, titleFontSize, isPrint } = props
    
    useEffect(()=>{
    },[])
        
    const parseMeasureData = (measureData) => {
        return measureData.map((val) => {
            if(100 < val) {
                return 100
            } else {
                return val
            }
        }) 
    }

    const unstableData = parseMeasureData(measureData[0])
    const isUnstableValid = unstableData[0] != null && unstableData[1] != null
        && !isNaN(Number(unstableData[0])) && !isNaN(Number(unstableData[1]))
    const levelL = isUnstableValid ? getUnstableLevel(Number(unstableData[0])) : { text: '-', color: '#ccc', desc: '' }
    const levelR = isUnstableValid ? getUnstableLevel(Number(unstableData[1])) : { text: '-', color: '#ccc', desc: '' }

    // 50:50 기준 파이차트 비율 계산 (차이를 50 기준으로 반영)
    const toPieRatio = (valL, valR) => {
        const l = parseFloat(valL)
        const r = parseFloat(valR)
        const total = l + r
        if (total === 0) return [50, 50]
        const diff = ((l - r) / total) * 50
        return [
            parseFloat((50 + diff).toFixed(1)),
            parseFloat((50 - diff).toFixed(1))
        ]
    }

    return (
        <Box>
            <Box>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant={"subtitle1"} style={{fontSize: titleFontSize ? titleFontSize : fontSize}}>
                            불안정 상태
                        </Typography>
                        <Grid container>
                            <Grid item xs={10}>
                                <Box style={{height: 140, position: 'relative'}}>
                                    <HorizontalBar
                                        data={{
                                            labels: ['좌뇌', '우뇌'],
                                            datasets: [{
                                                data: [unstableData[0], unstableData[1]],
                                                backgroundColor: [levelL.color, levelR.color],
                                                borderColor: [levelL.color, levelR.color],
                                                borderWidth: 1,
                                            }]
                                        }}
                                        options={{
                                            responsive: true,
                                            maintainAspectRatio: false,
                                            legend: { display: false },
                                            tooltips: {
                                                callbacks: {
                                                    label: function (tooltipItem) {
                                                        return tooltipItem.xLabel + '%'
                                                    }
                                                }
                                            },
                                            animation: {
                                                onComplete: function () {
                                                    const chart = this;
                                                    const ctx = chart.ctx;
                                                    const fs = fontSize ? fontSize : 14;
                                                    ctx.font = 'bold ' + fs + 'px sans-serif';
                                                    ctx.fillStyle = '#333';
                                                    ctx.textAlign = 'left';
                                                    ctx.textBaseline = 'middle';
                                                    chart.data.datasets.forEach(function (dataset, di) {
                                                        const meta = chart.controller.getDatasetMeta(di);
                                                        meta.data.forEach(function (bar, index) {
                                                            const value = dataset.data[index];
                                                            ctx.fillText(value + '%', bar._model.x + 8, bar._model.y);
                                                        });
                                                    });

                                                    // 구간 배경 색상
                                                    const xAxis = chart.scales['x-axis-0'];
                                                    const yAxis = chart.scales['y-axis-0'];
                                                    const top = yAxis.top;
                                                    const bottom = yAxis.bottom;
                                                    const zones = [
                                                        { from: 0, to: 25, color: 'rgba(76,175,80,0.08)' },
                                                        { from: 25, to: 50, color: 'rgba(255,193,7,0.08)' },
                                                        { from: 50, to: 75, color: 'rgba(255,152,0,0.10)' },
                                                        { from: 75, to: 100, color: 'rgba(244,67,54,0.10)' },
                                                    ];
                                                    zones.forEach(function(zone) {
                                                        const left = xAxis.getPixelForValue(zone.from);
                                                        const right = xAxis.getPixelForValue(zone.to);
                                                        ctx.fillStyle = zone.color;
                                                        ctx.fillRect(left, top, right - left, bottom - top);
                                                    });
                                                }
                                            },
                                            scales: {
                                                xAxes: [{
                                                    display: true,
                                                    gridLines: {
                                                        display: true,
                                                        color: 'rgba(0,0,0,0.08)',
                                                    },
                                                    ticks: {
                                                        fontColor: '#666',
                                                        fontSize: fontSize ? fontSize : 12,
                                                        min: 0,
                                                        max: 100,
                                                        stepSize: 25,
                                                        callback: function (value) {
                                                            return value + '%'
                                                        }
                                                    },
                                                }],
                                                yAxes: [{
                                                    display: true,
                                                    barPercentage: 0.8,
                                                    categoryPercentage: 0.8,
                                                    ticks: {
                                                        fontColor: '#333',
                                                        fontSize: fontSize ? fontSize : 14,
                                                        fontStyle: 'bold',
                                                    },
                                                    gridLines: {
                                                        display: false,
                                                    },
                                                }]
                                            }
                                        }}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={2} style={{display: 'flex', justifyContent: 'flex-start'}}>
                                <PieChart
                                    defaultData={toPieRatio(unstableData[0], unstableData[1]).reverse()}
                                    height={100}
                                    width={100}
                                    fontSize={fontSize}
                                    labels={['우뇌', '좌뇌']}
                                    xLabelDisplay={true}
                                    useColorIndex={true}
                                    colors={[levelR.color, levelL.color]}
                                />
                            </Grid>
                        </Grid>
                        {!isPrint && isUnstableValid && <>
                            {/* 구간 범례 */}
                            <Box display={'flex'} mt={1} ml={1}>
                                {[
                                    { label: '안정', color: '#4CAF50' },
                                    { label: '경미', color: '#FFC107' },
                                    { label: '주의', color: '#FF9800' },
                                    { label: '심각', color: '#F44336' },
                                ].map((item, i) => (
                                    <Box key={i} display={'flex'} alignItems={'center'} mr={2}>
                                        <Box style={{width: 10, height: 10, backgroundColor: item.color, borderRadius: 2, marginRight: 4}} />
                                        <Typography variant={'caption'} style={{color: '#555'}}>{item.label}</Typography>
                                    </Box>
                                ))}
                            </Box>
                            {/* 설명 박스 */}
                            <Box mt={1} p={1.5} style={{backgroundColor: '#f9f9f9', borderRadius: 8}}>
                                {[
                                    { label: '좌뇌', level: levelL },
                                    { label: '우뇌', level: levelR },
                                ].map((item, i) => (
                                    <Box key={i} mb={i === 0 ? 0.5 : 0}>
                                        <Typography variant={'body2'} style={{color: '#333', fontWeight: 'bold', display: 'inline'}}>
                                            {item.label}
                                        </Typography>
                                        <Typography variant={'body2'} style={{color: item.level.color, fontWeight: 'bold', display: 'inline', marginLeft: 8}}>
                                            [{item.level.text}]
                                        </Typography>
                                        <Typography variant={'body2'} style={{color: '#666', display: 'inline', marginLeft: 8}}>
                                            {item.level.desc}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        </>}
                    </Grid>
                    <Grid item xs={12}>
                        <ResultBarPie 
                            title={"산만율(%)"}
                            data={parseMeasureData(measureData[1])}
                            pieData={toPieRatio(measureData[1][0], measureData[1][1])}
                            labels={['좌뇌', '우뇌']}
                            useEachPieChart={false}
                            barChartColor={['#60C3F7','#F8807A']}
                            pieChartColor={['#60C3F7','#F8807A']}
                            pieLabelPosition={'right'}
                            lineChartXs={10}
                            pieChartXs={2}
                            pieAlignLeft={true}
                            fontSize={fontSize}
                            titleFontSize={titleFontSize}
                        />
                    </Grid>
                    {measureData[3] &&
                    <Grid item xs={12}>
                        <ResultBarPie
                            title={"행동 우세율(%)"}
                            data={measureData[3]}
                            labels={['좌뇌', '우뇌']}
                            useEachPieChart={false}
                            barChartColor={['#60C3F7','#A9D8AA']}
                            pieChartColor={['#60C3F7','#A9D8AA']}
                            pieLabelPosition={'right'}
                            lineChartXs={10}
                            pieChartXs={2}
                            pieAlignLeft={true}
                            suggestedMax={100}
                            fontSize={fontSize}
                            titleFontSize={titleFontSize}
                        />
                    </Grid>
                    }
                </Grid>
            </Box>
        </Box>
    );
}



export default ResultEmotion
